import { MenuItem, Select } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

interface StateSelectProps {
  sweepstakeStates: string[]
  disabledStates?: string[]
  disabled?: boolean
  style?: React.CSSProperties
}

export const SweepstakeStateSelect = ({
  sweepstakeStates,
  disabledStates = [],
  disabled,
  style,
}: StateSelectProps) => {
  const {
    control,
    formState: { defaultValues },
  } = useFormContext()

  return (
    <Controller
      render={({ field }) => (
        <Select
          {...field}
          style={style}
          labelId="Sweepstake.state"
          variant="outlined"
          fullWidth
          id="Sweepstake.state"
          disabled={disabled}
        >
          {sweepstakeStates.map((state: string) => (
            <MenuItem
              value={state}
              key={state}
              disabled={disabledStates.includes(state)}
            >
              {state.replace(/([A-Z])/g, ' $1').replace(/^ +/, '')}
            </MenuItem>
          ))}
        </Select>
      )}
      name="Sweepstake.state"
      control={control}
      defaultValue={defaultValues?.Sweepstake.state}
    />
  )
}
